import { Selector } from '@ngxs/store';
import { ProfileStateModel } from './profile-state.model';
import { ProfileState } from './profile.state';
import { User } from '@app/entities/users/interfaces/user';
import { UserProfile } from '@app/entities/users/interfaces/user-profile';
import { UserBillingInfo } from '@app/entities/users/interfaces/user-billing-info';
import { UserPaymentInfo } from '@app/entities/users/interfaces/user-payment-info';

export class ProfileSelectors {
  @Selector([ProfileState])
  static user(state: ProfileStateModel): User | undefined {
    return state.user;
  }

  @Selector([ProfileState])
  static profile(state: ProfileStateModel): UserProfile | undefined {
    return state.user?.profile;
  }

  @Selector([ProfileState])
  static billing_info(state: ProfileStateModel): UserBillingInfo | undefined {
    return state.user?.billing_info;
  }

  @Selector([ProfileState])
  static payment_info(state: ProfileStateModel): UserPaymentInfo | undefined {
    return state.user?.payment_info;
  }
}
